export const PreferredContactMethod = {
	Text: 'Text',
	Email: 'Email',
	PhoneCall: 'PhoneCall',
};
